import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    title: "1. Information we collect",
    paragraphs: [
      "Sellcraft collects the photos you choose to scan, the listings you create, and basic account information provided through Google Play when you subscribe.",
      "We also collect anonymous usage analytics to improve item identification and pricing accuracy.",
    ],
  },
  {
    title: "2. How we use your information",
    paragraphs: [
      "Photos are processed by our AI systems to identify items, estimate prices and generate listing content. Generated listings are stored so you can access your history and profit dashboard.",
      "We do not sell your photos, listings or personal data to third parties.",
    ],
  },
  {
    title: "3. Marketplace data",
    paragraphs: [
      "When you publish to eBay, Facebook or Gumtree, the listing content you approve is shared with that marketplace under their own terms and privacy policies.",
    ],
  },
  {
    title: "4. Data retention & deletion",
    paragraphs: [
      "You can delete individual scans and listings at any time in the app. To request full account data deletion, contact us at the support email below.",
    ],
  },
  {
    title: "5. Security",
    paragraphs: [
      "We use industry-standard encryption in transit and at rest to protect your data.",
    ],
  },
  {
    title: "6. Contact",
    paragraphs: [
      "Questions about this policy can be sent to support@sellcraft.app.",
    ],
  },
];

const PrivacyPage = () => (
  <LegalPage
    testId="privacy-page"
    pageTitle="Privacy Policy"
    lastUpdated="1 July 2026"
    sections={SECTIONS}
  />
);

export default PrivacyPage;
